(()=>{
  const __shopifySectionId=document.currentScript?.dataset.sectionId||'';
  if(window.__yurchakLoyaltyBridgeBound)return;
  window.__yurchakLoyaltyBridgeBound=true;
  const marker=document.querySelector('[data-yurchak-loyalty-bridge]');
  const storageKey='yurchak_loyalty_capture_v1';
  const day=86400000;
  const sourceFor=(form)=>form.matches('.ynl__form')?'source-homepage-newsletter':form.id==='ContactFooter'?'source-footer-newsletter':'source-newsletter-section';
  const appendTags=(form)=>{
    let input=form.querySelector('input[name="contact[tags]"]');
    if(!input){input=document.createElement('input');input.type='hidden';input.name='contact[tags]';form.prepend(input)}
    const tags=(input.value||'').split(',').map(v=>v.trim()).filter(Boolean);
    ['newsletter','yurchak-loyalty','loyalty-subscriber',sourceFor(form)].forEach(tag=>{if(!tags.includes(tag))tags.push(tag)});
    input.value=tags.join(',');
  };
  const setSubscribedClass=()=>document.documentElement.classList.add('yurchak-loyalty-subscribed');
  const markSubscribed=(source='known-subscriber')=>{
    setSubscribedClass();
    try{localStorage.setItem(storageKey,JSON.stringify({type:'subscribed',until:Date.now()+365*day}))}catch(e){}
    window.dispatchEvent(new CustomEvent('yurchak:loyalty-subscribed',{detail:{source}}));
  };
  const restoreKnownState=()=>{
    try{const state=JSON.parse(localStorage.getItem(storageKey)||'{}');if(state.type==='subscribed'&&state.until>Date.now())setSubscribedClass()}catch(e){}
  };
  const bind=()=>{
    restoreKnownState();
    document.querySelectorAll('.ynl__form, form.newsletter-form').forEach(form=>{
      if(!form.querySelector('input[name="contact[email]"]'))return;
      appendTags(form);
      if(form.dataset.ylcBridgeBound==='1')return;
      form.dataset.ylcBridgeBound='1';
      form.addEventListener('submit',()=>appendTags(form));
    });
    if(marker?.dataset.customerSubscribed==='true')markSubscribed('logged-in-subscriber');
    if(document.querySelector('.ynl__message--success'))markSubscribed('homepage-newsletter');
    if(document.querySelector('.newsletter-form__message--success'))markSubscribed('newsletter-section');
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind,{once:true});else bind();
  document.addEventListener('shopify:section:load',bind);
})();
